/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Tab, Tabs } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { CustomerModel, PartnerModel, VendorModel } from "../../Utils/Models";
import { ValidatorForm } from "react-material-ui-form-validator";
import AddOrUpdateModel from "../GenericComponents/AddOrUpdateModel";
import { Vocabulary } from "../../Utils/Vocabulary";
import Customer from "./Customer";
import Addresses from "./Addresses";

type CustomerMainPageProps = {
  editCustomer: CustomerModel | null;
  open: boolean;
  addOrUpdateCustomer: (customer: CustomerModel | VendorModel | PartnerModel) => void;
  onClose: () => void;
  fromOrder: boolean;
  title?: string;
};
export default function CustomerMainPage(props: CustomerMainPageProps) {
  const { editCustomer, open, fromOrder, addOrUpdateCustomer, onClose, title } =
    props;
  const ref: any = useRef();
  const [customer, setCustomer] = useState<CustomerModel | VendorModel | PartnerModel>(
    title === Vocabulary.vendorsList
      ? new VendorModel()
      : title === Vocabulary.partnersList
        ? new PartnerModel()
        : new CustomerModel()
  );
  const [pressOnSubmit, setPressOnSubmit] = useState(false);
  const [value, setValue] = useState(0);

  const buttons = fromOrder ? (
    <Button
      onClick={resetCustomer}
      variant="contained"
      style={{ marginBottom: 10, marginTop: 10, color: "white" }}
      fullWidth
      color="secondary"
    >
      {Vocabulary.reset}
    </Button>
  ) : null;

  /**
   *
   */
  useEffect(() => {
    if (editCustomer) {
      setCustomer(editCustomer);
    } else {
      setCustomer(
        title === Vocabulary.vendorsList
          ? new VendorModel()
          : title === Vocabulary.partnersList
            ? new PartnerModel()
            : new CustomerModel()
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editCustomer]);

  /**
   *
   */
  useEffect(() => {
    if (pressOnSubmit) {
      ref.current.submit();
      //reset the value
      handleChangePressOnSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressOnSubmit]);

  /**
   *
   */
  function handleChangePressOnSubmit() {
    setPressOnSubmit(!pressOnSubmit);
  }
  /**
   *
   * @param event
   * @param newValue
   */
  function handleChangeValue(event: React.SyntheticEvent, newValue: number) {
    setValue(newValue);
  }

  /**
   *
   * @param value
   */
  function handleChangeCustomer(value: CustomerModel | VendorModel) {
    setCustomer(value);
  }

  /**
   *
   */
  function showInformation() {
    switch (value) {
      case 0:
        return (
          <Customer
            customer={customer}
            handleChangeCustomer={handleChangeCustomer}
          />
        );
      case 1:
        return (
          <Addresses
            customer={customer}
            handleChangeCustomer={handleChangeCustomer}
          />
        );
      default:
        break;
    }
  }

  /**
   *
   */
  function resetCustomer() {
    if (editCustomer) {
      setCustomer(editCustomer);
    } else {
      setCustomer(
        title === Vocabulary.vendorsList
          ? new VendorModel()
          : title === Vocabulary.partnersList
            ? new PartnerModel()
            : new CustomerModel()
      );
    }
  }

  return (
    <ValidatorForm ref={ref} onSubmit={() => addOrUpdateCustomer(customer)}>
      <AddOrUpdateModel
        open={open}
        title={title ? title : Vocabulary.customer}
        onClose={onClose}
        isSubmit={true}
        addOrUpdateItem={() => null}
        handleChangePressOnSubmit={handleChangePressOnSubmit}
        buttons={buttons ? buttons : null}
      >
        <Tabs value={value} onChange={handleChangeValue} textColor="inherit">
          <Tab label={Vocabulary.customer} />
          <Tab label={Vocabulary.address} />
        </Tabs>
        {showInformation()}
      </AddOrUpdateModel>
    </ValidatorForm>
  );
}
